import { all } from 'redux-saga/effects';

import accountSaga from './accountSaga';
import authSaga from './authSaga';
import functionSaga from './functionSaga';
import systemSaga from './systemSaga';
import bidCaseReviewSaga from './bidCaseReviewSaga';

export default function* rootSaga() {
    yield all([
        accountSaga(),
        authSaga(),
        functionSaga(),
        systemSaga(),
        bidCaseReviewSaga()
    ]);
}